import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import EsimQrCodeBlockData from "../../../Models/Content/EsimQrCodeBlockData";
import EsimQrCodeBlock from "./EsimQrCodeBlock";

export default class EsimQrCodeBlockWrapper extends EpiComponent<EsimQrCodeBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ["esim-qr-code-block"];

    return (
      <div className={cssClasses.join(" ")}>
        <EsimQrCodeBlock iContent={this.props.data} context={this.getContext()} />
      </div>
    );
  }
}
